import {doScrolling} from 'CommonUtils/scroll.js'

let allowedCountries = [];
const elAppLoader = document.querySelector('.app-loader');
const elScrollBtn = document.querySelector('.scroll-btn');
const elAppContainer = document.getElementById('payments-app-container');
const elMainHeader = document.querySelector('.main-header');

async function onInit() {


    elScrollBtn.addEventListener('click', ()=>{
        requestAnimationFrame(onBtnClick)
    })

    elAppLoader.classList.add('show');

    let langCode = document.body.dataset.languageCode;

    //determine if the page is SA or AE
    if (langCode === 'ar') langCode = (window.location.host === 'www.iforexarab.com') ? 'ar_ae' : 'ar_sa';

    //determine if Euro Spanish or Mexican
    if (langCode === 'es') langCode = (window.location.host === 'www.iforex.mx') ? 'es' : 'es_eu';

    langCode = langCode === 'hi' && languageAttributes.spokenLanguageCode === 'hi' ? 'hi' : langCode;    


    if(langCode === 'hi') langCode = languageAttributes.spokenLanguageCode === 'hi' ? 'hi' : 'en'; 

    langCode = langCode === 'kz' ? 'ru' : langCode;

    const broker = +document.body.dataset.broker;
    let defaultCountry = window.readcookie('geoip');
    
    allowedCountries = await getAllowedCountries(broker);
    const isAllowed = allowedCountries.includes(defaultCountry);

    if (!defaultCountry || !isAllowed) {
        //No GeoIP cookie or Not alllowed Country
        defaultCountry = getDefaultCountryByLangCode(langCode);
    }

    let apiLangCode = handleApiLangs(langCode)

    const app = new PaymentMethods.Application(elAppContainer, apiLangCode, broker, defaultCountry, langCode);
    app.init();

    elAppLoader.classList.remove('show');

}

async function getAllowedCountries(broker) {

    let response = await fetch(`https://content.webapi-services.net/api/allowedRegistrationCountries?b=${broker}&env=${API_ENV}`);

    if (!response.ok) {
        throw new Error(`An error occurred: ${response.status}`);
    }
    return response.json();
}


function getDefaultCountryByLangCode(lang) {
    let res;
    switch (lang) {
        case 'hi': res = 'IN'; break;
        case 'es': res = 'MX'; break;
        case 'ja': res = 'JA'; break;
        case 'tw':  res = 'TW' ; break;
        case 'cn': res = 'CN'; break;
        case 'cz': res = 'CZ'; break;
        case 'hu': res = 'HU'; break;
        case 'ko': res = 'KR'; break;
        case 'ru': res = 'AL'; break;
        case 'th': res = 'TH'; break;
        case 'de': res = 'DE'; break;
        case 'nl': res = 'NL'; break;
        case 'el': res = 'GR'; break;
        case 'fr': res = 'FR'; break;
        case 'it': res = 'IT'; break;
        case 'pl': res = 'PL'; break;
        case 'en_sa': res = 'SA'; break;
        case 'en_eu': res = 'RO'; break;
        case 'ar_sa': res = 'SA'; break;
        case 'ar_ae': res = 'EG'; break;
        case 'es_eu': res = 'ES'; break;
        
        default: res = 'JO'; break;

    }

    res = languageAttributes.languageCode === 'hi' ? 'IN' : res; 

    return res;
}

function handleApiLangs(lang) {
    //Modifies page lang code to fxnet lang code
    let res;

    switch (lang) {
        case 'en_eu':
        case 'en_sa': res = 'en'; break;
        case 'ar_sa':
        case 'ar_ae': res = 'ar'; break;
        case 'cn': res = 'zh'; break;
        case 'es_eu': res = 'es'; break;
        case 'cz': res = 'cs'; break;
        case 'tw': res = 'tw'; break;
        case 'hi': res  = 'hi' ; break;

        default: res = lang; break;
    }
    return res;
}

function onBtnClick(){
    const bodyTop = document.body.getBoundingClientRect().top,
          appTop = elAppContainer.getBoundingClientRect().top,
          elMainHeaderHeight = elMainHeader.getBoundingClientRect().height,
          appCoordY = appTop - bodyTop,
          isUserScrolled = !!window.pageYOffset,
          to = isUserScrolled ? appCoordY  : appCoordY - elMainHeaderHeight;
    doScrolling(to, 300);
}

onInit();